import { render, staticRenderFns } from "./Pureland.vue?vue&type=template&id=4ef06ebc&scoped=true&"
import script from "./Pureland.vue?vue&type=script&lang=js&"
export * from "./Pureland.vue?vue&type=script&lang=js&"
import style0 from "./Pureland.vue?vue&type=style&index=0&id=4ef06ebc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef06ebc",
  null
  
)

export default component.exports